export const SUPPORTED_LANGUAGE: Record<string, string> = {
  TH: "th",
  EN: "en",
};
